// ui-kit/export-guard — slot guard export (diisi shell/core saat login; pola core/nav).
// Helper unduh (downloadFile/downloadXLS) memanggil `passExportGuard` sebelum mengunduh →
// kontrol export terpusat, tak bisa terlewat di 23+ titik. Fail-CLOSED (anti-pencurian DB).
let guard: ((filename: string) => Promise<boolean>) | null = null;
export const setExportGuard = (fn: (filename: string) => Promise<boolean>): void => { guard = fn; };
/** true = boleh unduh. Belum ter-registrasi (mustahil pasca-login) → false (fail-closed). */
export const passExportGuard = (filename: string): Promise<boolean> => guard ? guard(filename) : Promise.resolve(false);
